import { render } from "./TrendsReport.vue?vue&type=template&id=05eee98c&scoped=true"
import script from "./TrendsReport.vue?vue&type=script&lang=js"
export * from "./TrendsReport.vue?vue&type=script&lang=js"

import "./TrendsReport.vue?vue&type=style&index=0&id=05eee98c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05eee98c"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtnDropdown,QBtnGroup,QBtn,QRadio,QTooltip,QBadge});qInstall(script, 'directives', {ClosePopup});
